import styles from "./loader.module.css";
import React, {
  useEffect,
  useRef,
  useState,
} from "react";
import lottie from "lottie-web";
import animationData from "./img/animation/loader.json";
import texts from "../../assets/ContextProvider/textsLocalized.json"

const Loader = props => {
  const refLoader = useRef(null);
  const containerRef = useRef(null);
  const [isMoreWaiting, setIsMoreWaiting] = useState(false);
  const isMoreTimeout = useRef(null);
  const body = document.body;


  useEffect(() => {
    const animation = lottie.loadAnimation({
      container: containerRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animationData,
    });

    animation.setSpeed(3.5);

    return () => {
      animation.destroy();
    };
  }, []);


  useEffect(() => {
    if (props.isLoading) {
      body.classList.add(styles["non-scroll"]);
      refLoader.current.classList.remove(styles["hide"]);
      isMoreTimeout.current = setTimeout(() =>
          setIsMoreWaiting(true),
        15000);
    } else {
      body.classList.remove(styles["non-scroll"]);
      refLoader.current.classList.add(styles["hide"]);
      setIsMoreWaiting(false);
    }

    return () => {
      clearTimeout(isMoreTimeout.current);
    }
  }, [props.isLoading]);


  return (
    <div ref={refLoader} className={`${styles['loader__wrapper']} ${styles['hide']}`}>
      <div className={styles['loader']}>
        <div
          className={styles['loader__logo']}
          ref={containerRef}
          style={{width: "100%", height: "100%"}}
        />
      </div>
      <div className={styles['loader__text']}>
        {isMoreWaiting ? texts.loader['description-long-time'] : texts.loader['description']}
      </div>
    </div>
  );
};

export default Loader;
